import { useRef } from "react";
import { normalizeReadingUid } from "./readingStorageScope";

// A chapter left open across logout → login still belongs to the account
// that opened it. Persist last-read / verse-focus / positions only while the
// current uid matches the owner of this chapterId in this mount.
export const useReaderPersistGate = (chapterId, uid) => {
  const ownedChapterRef = useRef(chapterId);
  const ownedUidRef = useRef(normalizeReadingUid(uid));

  if (ownedChapterRef.current !== chapterId) {
    ownedChapterRef.current = chapterId;
    ownedUidRef.current = normalizeReadingUid(uid);
  }

  return Boolean(chapterId) && ownedUidRef.current === normalizeReadingUid(uid);
};
